<script setup lang="ts">
import { computed } from "vue";

import { boardActions } from "@/action/boardActions";
import { toggleActions } from "@/action/toggleActions";
import SightlinePanel from "@/components/Sightline/SightlinePanel.vue";
import SearchResultsPanel from "@/components/search/SearchResultsPanel.vue";
import { useShortcuts } from "@/composables/useShortcuts";
import { useDrawStore } from "@/store/draw";

import BoardHistoryPanel from "./internal/ActivityPanel/BoardHistoryPanel.vue";
import StickyActivityPanel from "./internal/ActivityPanel/StickyActivityPanel.vue";
import ArtObjectivesPanel from "./internal/ArtObjectivesPanel/ArtObjectivesPanel.vue";
import BoardConfigPanel from "./internal/BoardConfigPanel.vue";
import BottomMenu from "./internal/BottomMenu/BottomMenu.vue";
import ContextMenu from "./internal/ContextMenu/ContextMenu.vue";
import IssueSelectorPanel from "./internal/IssueSelector/IssueSelectorPanel.vue";
import SideMenu from "./internal/SideMenu/SideMenu.vue";
import SwitchSessionPanel from "./internal/SwitchSessionPanel/SwitchSessionPanel.vue";
import TimerPanel from "./internal/Timer/TimerPanel.vue";
import TopMenu from "./internal/TopMenu/TopMenu.vue";

const { registerShortcut } = useShortcuts();
registerShortcut(boardActions.screenshot, { prevent: false });
registerShortcut(toggleActions.showShortcuts);
registerShortcut(toggleActions.showSettings);

const drawMode = computed(() => useDrawStore().active);
</script>

<template>
  <div data-no-screenshot data-no-rectangle-select>
    <ContextMenu />

    <TopMenu v-if="!drawMode" />
    <SideMenu v-if="!drawMode" />
    <BottomMenu />

    <SearchResultsPanel />
    <TimerPanel />
    <StickyActivityPanel />
    <BoardHistoryPanel />
    <SwitchSessionPanel />
    <IssueSelectorPanel />
    <ArtObjectivesPanel />
    <BoardConfigPanel />
    <SightlinePanel />
  </div>
</template>
